import { motion } from "framer-motion";
import { Check } from "lucide-react";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/4d132632-2d85-4b88-a2d9-3e5d50eb738b/images/484ab9db646325bea8cc0f318d1137118b2ec3f6609524f2e59e3c333189182f.png";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-center grain overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_IMG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/80 to-[#0A0A0A]/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-[#0A0A0A]/40" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full pt-28 pb-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <img
            src="https://customer-assets.emergentagent.com/job_adult-baseball-hub/artifacts/b8ws7h83_wabl%20logo.jpg"
            alt="Weekend Adult Baseball League logo"
            data-testid="hero-logo"
            className="h-28 sm:h-36 w-auto mb-8 drop-shadow-[0_8px_24px_rgba(0,0,0,0.6)]"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.05 }}
        >
          <span className="inline-flex items-center gap-2 text-[#F4A261] text-xs font-bold uppercase tracking-[0.3em] border border-[#F4A261]/30 px-4 py-2 mb-8">
            <span className="w-2 h-2 bg-[#F4A261] rounded-full animate-pulse" /> Now Forming · Virginia
          </span>
        </motion.div>

        <motion.h1
          data-testid="hero-headline"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="text-6xl sm:text-7xl lg:text-8xl uppercase leading-[0.9] tracking-tighter max-w-4xl"
        >
          Your Playing Days <span className="text-[#FF3B30]">Aren't Over.</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25 }}
          className="mt-8 text-lg sm:text-xl text-[#C7CDD4] max-w-xl font-medium leading-relaxed"
        >
          The Weekend Adult Baseball League. The game you love, on the schedule you actually need. Competitive ball — weekends only.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-10 flex flex-col sm:flex-row gap-4"
        >
          <a
            href="#signup"
            data-testid="hero-signup-cta"
            className="font-heading uppercase tracking-wide bg-[#FF3B30] text-white hover:bg-[#FF6B63] hover:-translate-y-1 transition-all shadow-[4px_4px_0px_0px_rgba(255,255,255,0.15)] hover:shadow-[6px_6px_0px_0px_rgba(255,255,255,0.35)] px-8 py-4 text-center"
          >
            Claim Your Spot
          </a>
          <a
            href="#about"
            data-testid="hero-learn-cta"
            className="font-heading uppercase tracking-wide border border-white/20 text-white hover:border-white hover:-translate-y-1 transition-all px-8 py-4 text-center"
          >
            Learn More
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.7 }}
          className="mt-16 flex flex-wrap gap-x-8 gap-y-3 text-sm font-bold uppercase tracking-[0.15em] text-[#8A94A0]"
        >
          {["Competitive", "Weekend-Only", "Family-Friendly", "No Drama"].map((t) => (
            <span key={t} className="flex items-center gap-2">
              <Check size={16} className="text-[#FF3B30]" strokeWidth={3} /> {t}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
